import { conv2dTranspose } from "@tensorflow/tfjs-core";
import { DateTime } from "luxon";

let eyesClosed = 0;

let last_eye_blink_time = DateTime.now().toSeconds();

function euclaideanDistance(point: any, point1: any) {
  const { x, y } = point;
  const { x: x1, y: y1 } = point1;
  const distance = Math.sqrt(Math.pow(x1 - x, 2) + Math.pow(y1 - y, 2));
  return distance;
}
function blinkRatio(landmarks: any) {
  const rh_right = landmarks[133];
  const rh_left = landmarks[33];

  const rv_top_l = landmarks[160];
  const rv_bottom_l = landmarks[144];

  const rv_top_r = landmarks[158];
  const rv_bottom_r = landmarks[153];

  const lh_right = landmarks[362];
  const lh_left = landmarks[263];

  const lv_top_l = landmarks[385];
  const lv_bottom_l = landmarks[380];

  const lv_top_r = landmarks[387];
  const lv_bottom_r = landmarks[373];

  const rhDistance = euclaideanDistance(rh_right, rh_left);
  const rvDistance =
    euclaideanDistance(rv_top_l, rv_bottom_l) +
    euclaideanDistance(rv_top_r, rv_bottom_r);
  const lvDistance =
    euclaideanDistance(lv_top_l, lv_bottom_l) +
    euclaideanDistance(lv_top_r, lv_bottom_r);
  const lhDistance = euclaideanDistance(lh_right, lh_left);

  // const reRatio = rhDistance / rvDistance;
  // const leRatio = lhDistance / lvDistance;
  // const ratio = (reRatio + leRatio) / 2;

  const earr = rvDistance / (rhDistance * 2);
  const earl = lvDistance / (lhDistance * 2);

  const ear = (earr + earl) / 2;

  return ear;
}

function detectBlinkingEyes(
  face: any,
  ctx: any,
  videoWidth: any,
  name: string
) {
  const box = face.box;

  ctx.save();
  ctx.translate(videoWidth, 0);
  ctx.scale(-1, 1);

  const ratio = blinkRatio(face.keypoints);

  if (ratio < 0.2) {
    // eye is blinking
    ctx.font = "16px  Arial";
    ctx.fillStyle = "yellow";
    ctx.textAlign = "center";
    ctx.fillText(
      "Liveness: Live",
      videoWidth - box.xMax + box.width / 2,
      box.yMax + 30
    );
    ctx.font = "16px  Arial";
    ctx.fillStyle = "yellow";
    ctx.textAlign = "center";
    ctx.fillText(
      `Name: ${name}`,
      videoWidth - box.xMax + box.width / 2,
      box.yMax + 50
    );

    last_eye_blink_time = DateTime.now().toSeconds();
  } else {
    if (DateTime.now().toSeconds() - last_eye_blink_time >= 2) {
      ctx.font = "16px  Arial";
      ctx.fillStyle = "#FF00FF";
      ctx.textAlign = "center";
      ctx.fillText(
        "Liveness: Spoof (Please Blink)",
        videoWidth - box.xMax + box.width / 2,
        box.yMax + 30
      );
    } else {
      ctx.font = "16px  Arial";
      ctx.fillStyle = "yellow";
      ctx.textAlign = "center";
      ctx.fillText(
        "Liveness: Live",
        videoWidth - box.xMax + box.width / 2,
        box.yMax + 30
      );
      ctx.font = "16px  Arial";
      ctx.fillStyle = "yellow";
      ctx.textAlign = "center";
      ctx.fillText(
        `Name: ${name}`,
        videoWidth - box.xMax + box.width / 2,
        box.yMax + 50
      );
    }
  }
  ctx.restore();
}

export { detectBlinkingEyes };
